import "./Services.css";
import {
  BarChart3,
  Building2,
  Megaphone,
  Home,
  Map,
  FileText,
  Briefcase,
  Users,ClipboardList
} from "lucide-react";
const services = [
  {
    title: "Sales",
    desc: "Selling residential, commercial, and industrial properties.",
    icon: <Home />
  },
  {
    title: "Investment Counsel",
    desc: "Expert guidance to help you achieve your investment objectives.",
    icon: <BarChart3 />
  },
  {
    title: "Real Estate Promotion",
    desc: "Marketing strategies to effectively promote your properties.",
    icon: <Megaphone />
  },
  {
    title: "Channel Partner Network Access",
    desc: "Instant entry to a well-nurtured network of sales partners for expanded reach and faster absorption.",
    icon: <Users />
  },
  {
    title: "Project Planning Support",
    desc: "Advisory on master planning, phasing, design alignment, and regulatory frameworks.",
    icon: <ClipboardList />
  },
  {
    title: "Hospitality & Property Management",
    desc: "Post-handover management solutions that elevate tenant/owner experience and preserve asset value.",
    icon: <Building2 />
  }
];

const Services = () => {
  return (
    <section className="services-wrapper" id="services">
      <div className="services-container">
        <h2 className="services-title">SERVICES</h2>

        <div className="services-grid">
          {services.map((item, index) => (
            <div className="service-card" key={index}>
              <div className="service-icon">{item.icon}</div>
              <div className="service-content">
                <h4>{item.title}</h4>
                <p>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
